import { CSSProperties } from 'react';
import styled from 'styled-components';

export const Container = styled.div`
	padding: 0 6%;
`;
export const Content = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 20px 0;

	.buttonPesquisa {
		background: var(--action-accent-surface);
		width: 15em;
		height: 4em;
	}
`;

export const Title = styled.h4`
	font-weight: 500;
	font-size: 31px;
	line-height: 36px;
	color: var(--text-primary);
	margin: 20px 10px;
`;

export const SubTitle = styled.span`
	line-height: 24px;
	letter-spacing: 0.5px;
	color: var(--text-primary);
	display: inline-block;
	margin-bottom: 20px;
`;

export const Form = styled.form`
	width: 100%;
	display: flex;
	flex-direction: column;
`;

export const HeaderModal = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const InputStyled: CSSProperties = {
	maxWidth: '360px',
	margin: '15px 0',
};
export const PaginationStyled: CSSProperties = {
	display: 'flex',
	justifyContent: 'center',
};
